<div data-cy="verification-card-container" class="row" [class.macOS-moz-padding]="isMacOS">
  @for (item of items; track item) {
    <div (click)="onItemClick(item)" [class.has-navigation]="hasNavigation" class="card-container">
      <div class="card row" [ngClass]="[getSummaryClass(item)]">
        @for (col of columns; track col) {
          <div data-cy="verification-list-card" [class.has-navigation]="hasNavigation">
            <ng-container *ngTemplateOutlet="$any(col).templateRef; context: {$implicit: item}"></ng-container>
          </div>
        }
      </div>
    </div>
  }
</div>
